/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Purchase_Next_UploadInputs */

const en_post_purchase_next_upload = /** @type {(inputs: Post_Purchase_Next_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next: Upload your first document`)
};

const es_post_purchase_next_upload = /** @type {(inputs: Post_Purchase_Next_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente: sube tu primer documento`)
};

/**
* | output |
* | --- |
* | "Next: Upload your first document" |
*
* @param {Post_Purchase_Next_UploadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const post_purchase_next_upload = /** @type {((inputs?: Post_Purchase_Next_UploadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Purchase_Next_UploadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_post_purchase_next_upload(inputs)
	return en_post_purchase_next_upload(inputs)
});